/* eslint-disable react/jsx-no-useless-fragment */
import React, { useCallback, useEffect } from 'react'
import PropTypes from 'prop-types'
import { debounce } from 'lodash'

import useMatchMedia from '~hooks/useMatchMedia'

import BtnAnimatedBurger from './components/BtnAnimatedBurger'

import NavModal from './components/NavModal'

const HeaderMobileNav = (props) => {
  const {
    navMenu,
    primaryText,
    primaryLink,
    secondaryText,
    secondaryLink,
    isLP,
    isModalOpen,
    setIsModalOpen,
    ...rest
  } = props

  const toggleModal = useCallback(
    debounce(
      () => {
        setIsModalOpen((prevState) => !prevState)
      },
      300,
      { leading: true, trailing: false }
    ),
    []
  )

  const handleHide = () => setIsModalOpen(false)

  const isDesktop = useMatchMedia('(min-width: 1024px)')

  useEffect(() => {
    if (isDesktop) setIsModalOpen(false)
  }, [isDesktop])

  return (
    <>
      <BtnAnimatedBurger
        {...rest}
        isModalOpen={isModalOpen}
        onClick={toggleModal}
      />
      <NavModal
        isLP={isLP}
        navMenu={navMenu}
        primaryText={primaryText}
        primaryLink={primaryLink}
        secondaryText={secondaryText}
        secondaryLink={secondaryLink}
        isModalOpen={isModalOpen}
        onHide={handleHide}
      />
    </>
  )
}

HeaderMobileNav.defaultProps = {
  className: undefined,
}

HeaderMobileNav.propTypes = {
  className: PropTypes.string,
  primaryText: PropTypes.string.isRequired,
  secondaryText: PropTypes.string.isRequired,
  primaryLink: PropTypes.shape({
    id: PropTypes.string,
    text: PropTypes.string,
    title: PropTypes.string,
    href: PropTypes.string,
  }).isRequired,
  secondaryLink: PropTypes.shape({
    id: PropTypes.string,
    text: PropTypes.string,
    title: PropTypes.string,
    href: PropTypes.string,
  }).isRequired,
  isLP: PropTypes.bool.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  setIsModalOpen: PropTypes.func.isRequired,
  navMenu: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      text: PropTypes.string,
      title: PropTypes.string,
      href: PropTypes.string,
      isDisabled: PropTypes.bool,
    })
  ).isRequired,
}

export default HeaderMobileNav
